import { z } from 'zod';

import { TimestampSchema } from './primitives.js';

/**
 * `directoryCuration/{outletId}` — PRIVATE super-admin companion to the
 * public `outletDirectory/{outletId}` row (feature: network-discovery).
 *
 * Exists because the public row is world-readable by design: a curation
 * reason ("suspected fraud", "photos violate guidelines") must never ride a
 * public document. Rules gate this collection to isSuperAdmin() only.
 * Keyed 1:1 by outletId so tooling can join without a lookup.
 */
export const DirectoryCurationSchema = z.object({
  outletId: z.string().min(1).describe('Mirrors the doc id; joins to outletDirectory/{outletId}'),
  hidden: z
    .boolean()
    .default(false)
    .describe(
      'SOURCE OF TRUTH for the super-admin hide. Lives here — not on the public row — because an operator can force the row itself to be deleted+rebuilt (opt-in cycle, outlet status flip), which would erase a row-borne flag. directorySync reads this doc on every re-projection (security review 2026-07-16, moderation-bypass finding)',
    ),
  note: z
    .string()
    .max(300)
    .default('')
    .describe('Why this row is featured/hidden — internal, super-admin eyes only'),
  updatedAt: TimestampSchema.describe('Last edit from /superadmin/directory'),
});
export type DirectoryCuration = z.infer<typeof DirectoryCurationSchema>;
